import { useEffect, useReducer } from 'react';

interface UseIsLoadingDelayedProps {
  loading: boolean;
  delay?: number;
}

export const useIsLoadingDelayed = ({
  loading,
  delay = 4000,
}: UseIsLoadingDelayedProps) => {
  const [isLoadingDelayed, setIsLoadingDelayed] = useReducer(
    (_: boolean, nextIsLoadingDelayed: boolean) => nextIsLoadingDelayed,
    false
  );

  useEffect(() => {
    if (!loading) return setIsLoadingDelayed(false);

    const timer = setTimeout(() => setIsLoadingDelayed(true), delay);

    return () => clearTimeout(timer);
  }, [loading, delay]);

  return isLoadingDelayed;
};
